import { Models } from './core';

export class ServiceCubicWasteProduct {
  public static ApiUrl = 'api/service-cubic-waste-products';

  Id: number;

  ProductId: number;
  Product?: Models.Product;
}